import { Stack, Text, CircularProgress } from '@ltvco/refresh-lib/theme';
import { CheckCircleOutlined, Circle } from '@mui/icons-material';
import {
  Timeline,
  TimelineConnector,
  TimelineItem,
  TimelineSeparator,
  TimelineContent,
} from '@mui/lab';
import { useEffect, useState } from 'react';

import { LOADING_STATUS } from 'components/ChatBV/constants';
import { LoadingStatus } from 'components/ChatBV/types';

export const TypingIndicator = ({
  loadingStatus,
}: {
  loadingStatus: LoadingStatus;
}) => {
  const [loadingStatusArray, setLoadingStatusArray] = useState<LoadingStatus[]>(
    [LOADING_STATUS.THINKING]
  );
  const loadingStatusIndex = loadingStatusArray.findIndex(
    (status) => status.message === loadingStatus.message
  );

  useEffect(() => {
    setLoadingStatusArray((prev) => {
      if (prev[prev.length - 1]?.message === loadingStatus.message) {
        return prev;
      }
      return [...prev, loadingStatus];
    });
  }, [loadingStatus.message]);

  return (
    <Timeline
      sx={{
        padding: 0,
        margin: 0,

        [`& .MuiTimelineItem-root::before`]: {
          display: 'none',
        },

        [`& .MuiTimelineContent-root`]: {
          py: 0.5,
        },
      }}
    >
      {loadingStatusArray.map((status, index) => {
        if (status.message === '') {
          return null;
        }
        return (
          <TimelineItem key={status.message} sx={{ display: 'flex', gap: 1 }}>
            <TimelineSeparator>
              {index < loadingStatusIndex ? (
                <CheckCircleOutlined sx={{ color: 'success.main' }} />
              ) : index === loadingStatusIndex ? (
                <CircularProgress size={20} />
              ) : (
                <Circle sx={{ color: 'divider' }} />
              )}
              {index < loadingStatusArray.length - 1 &&
                status.message !== LOADING_STATUS.FINISHING.message && (
                  <TimelineConnector />
                )}
            </TimelineSeparator>
            <TimelineContent>
              <Stack key={status.message} sx={{ display: 'flex', gap: 1 }}>
                <Text
                  sx={{
                    color:
                      index <= loadingStatusIndex
                        ? 'text.secondary'
                        : 'divider',
                    fontWeight: 'bold',
                    transition: 'color 0.5s ease-in-out',
                  }}
                >
                  {status.message}
                </Text>
                <Text
                  sx={{
                    color:
                      index <= loadingStatusIndex
                        ? 'text.secondary'
                        : 'divider',
                    transition: 'color 0.5s ease-in-out',
                  }}
                >
                  {status.subtitle}
                </Text>
              </Stack>
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  );
};
